// extracted by mini-css-extract-plugin
export default {"textContainer":"styles_textContainer__mA3OV","text":"styles_text__GyH6L"};